import React, { Fragment } from "react";
import FormSection from "../../../../components/wrappers/FormSection";
import { TEXTFIELDS, PERSONAL_INFO, ACCOUNT_INFO, SingleTextField, ADMIN_TEXT_FIELDS} from "../../../../components/form/SignUpTextFields";
import { useTranslation } from "react-i18next";
export default function AddUserToClinicFormBody({errors, register}) {
  const { t } = useTranslation();
  
  return (
    <Fragment>
      <FormSection title={t("PersonalInfo")}>
        {TEXTFIELDS.map((textfield, index) => {
          if (textfield.group === PERSONAL_INFO) {
            return (
              <SingleTextField
                key={index}
                textfield={textfield}
                t={t}
                errors={errors}
                register={register}
                
              />
            );
          }
        })}
      </FormSection>
      <FormSection title={t("AccountInfo")}>
        {ADMIN_TEXT_FIELDS.map((textfield, index) => {
          if (textfield.group === ACCOUNT_INFO) {
            return (
              <SingleTextField
                key={index}
                textfield={textfield}
                t={t}
                errors={errors}
                register={register}
              />
            );
          }
        })}
      </FormSection>
    </Fragment>
  );
}
